import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { color: "primary" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_date_range_selecter = _resolveComponent("date-range-selecter");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_container = _resolveComponent("v-container");
    const _component_v_table = _resolveComponent("v-table");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_v_container, { color: "primary" }, {
            default: _withCtx(() => [
                _createVNode(_component_date_range_selecter, {
                    "start-date": _ctx.startDate,
                    "end-date": _ctx.endDate,
                    "onUpdate:startDate": _cache[0] || (_cache[0] = ($event) => (_ctx.startDate = $event)),
                    "onUpdate:endDate": _cache[1] || (_cache[1] = ($event) => (_ctx.endDate = $event))
                }, null, 8, ["start-date", "end-date"]),
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.timeSpan,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.timeSpan) = $event)),
                    inline: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                            label: "月次",
                            value: "monthly"
                        }),
                        _createVNode(_component_v_radio, {
                            label: "週次",
                            value: "weekly"
                        }),
                        _createVNode(_component_v_radio, {
                            label: "日次",
                            value: "daily"
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                    onClick: _ctx.fetchKPIData,
                    color: "accent"
                }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("データ取得")
                    ])),
                    _: 1,
                    __: [3]
                }, 8, ["onClick"])
            ]),
            _: 1
        }),
        _createVNode(_component_v_container, { class: "scrollable-container" }, {
            default: _withCtx(() => [
                (_ctx.kpiDataList.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_table, {
                        key: 0,
                        class: "kpiDataTable"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("thead", _hoisted_1, [
                                _createElementVNode("tr", null, [
                                    _cache[4] || (_cache[4] = _createElementVNode("th", null, "KPI Metrics", -1)),
                                    _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                            key: kpiData.GeneratedAt.toString(),
                                            color: "primary"
                                        }, _toDisplayString(kpiData.StartDate.toString().slice(0, 10)), 1));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Planner, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[6] || (_cache[6] = _createElementVNode("th", null, "Planner", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Planner[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Company, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[7] || (_cache[7] = _createElementVNode("th", null, "Company", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Company[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Job, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[8] || (_cache[8] = _createElementVNode("th", null, "Job", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Job[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Contract, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[9] || (_cache[9] = _createElementVNode("th", null, "Contract", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Contract[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Shift, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[10] || (_cache[10] = _createElementVNode("th", null, "Shift", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Shift[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].ShiftRequest, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[11] || (_cache[11] = _createElementVNode("th", null, "ShiftRequest", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.ShiftRequest[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Attendance, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("th", null, "Attendance", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Attendance[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList[0].Revenue, (value, key) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: key.toString()
                                    }, [
                                        _cache[13] || (_cache[13] = _createElementVNode("th", null, "Revenue", -1)),
                                        _createElementVNode("th", null, _toDisplayString(key), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDataList, (kpiData) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: `${kpiData.GeneratedAt.toString()}-${key.toString()}`
                                            }, _toDisplayString(kpiData.Revenue[key].toLocaleString("ja-JP")), 1));
                                        }), 128))
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
